import { Injectable } from '@angular/core';
import { ValidatableSelectableJob } from 'src/app/shared/components/select-jobs-grid/select-job.models';
import { SelectJobsService } from './select-jobs.service';

export enum JobSelectValidationMode {
    None,
    OnePerEntity,
    OneActivePerIngestMode
}
@Injectable({
    providedIn: 'root'
})
export class SelectJobsValidateService {
    constructor(private selectJobsService: SelectJobsService) {}
    public get selectionIsValid(): boolean {
        return this._selectionIsValid;
    }
    private _selectionIsValid = true;

    public refreshValidity(
        jobs: Array<ValidatableSelectableJob>,
        validationMode: JobSelectValidationMode = JobSelectValidationMode.None
    ): void {
        switch (validationMode) {
            case JobSelectValidationMode.OnePerEntity:
                this.checkForOneJobSelectionPerEntity(jobs);
                break;
            case JobSelectValidationMode.OneActivePerIngestMode:
                this.checkForOneActiveJobPerIngestMode(jobs);
                break;
            case JobSelectValidationMode.None:
            default:
                return;
        }
    }

    private checkForOneJobSelectionPerEntity(jobs: Array<ValidatableSelectableJob>): void {
        const jobsByEntityId = this.selectJobsService.getJobsByEntityId(jobs) as Map<
            number,
            ValidatableSelectableJob[]
        >;
        jobsByEntityId.forEach(entityJobs => {
            const isValid = entityJobs.filter(j => j.isSelected).length < 2;
            entityJobs.forEach(j => (j.valid = isValid));
        });
        this._selectionIsValid = jobs.every(j => j.valid);
    }

    private checkForOneActiveJobPerIngestMode(jobs: Array<ValidatableSelectableJob>): void {
        const jobsByEntityId = this.selectJobsService.getJobsByEntityId(jobs) as Map<
            number,
            ValidatableSelectableJob[]
        >;
        jobsByEntityId.forEach(entityJobs => {
            const countOfActiveOrSelectedJobsPerIngestMode = entityJobs.reduce(
                (acc, o) => (
                    (acc[o.ingestMode as string] =
                        (acc[o.ingestMode as string] || 0) + (o.isSelected || o.activeFlag ? 1 : 0)),
                    acc
                ),
                {} as { [key: string]: number }
            );

            entityJobs.forEach(j => {
                if (j.isSelected && countOfActiveOrSelectedJobsPerIngestMode[j.ingestMode as string] > 1) {
                    j.valid = false;
                } else {
                    j.valid = true;
                }
            });
        });
        this._selectionIsValid = jobs.every(j => j.valid);
    }
}
